import { render } from "./ConnectionStatus.vue?vue&type=template&id=15a8178e"
import script from "./ConnectionStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectionStatus.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/ConnectionStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15a8178e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15a8178e', __exports__)) {
    api.reload('15a8178e', __exports__)
  }
  
  module.hot.accept("./ConnectionStatus.vue?vue&type=template&id=15a8178e", () => {
    api.rerender('15a8178e', render)
  })

}


export default __exports__